import * as z from "zod";
import { InlineLockAttrsSchema } from "./lock-types-schema";

/**
 * Mention node - references another entity (e.g., user, team member).
 */
const MentionNodeSchema_ = z.object({
  type: z.literal("mention"),
  instanceId: z.string(),
  selectionKey: z.string(),
  selectionLabel: z.string(),
  itemKey: z.string().optional(),
  itemLabel: z.string().optional(),
  config: z.record(z.string(), z.unknown()).optional(),
  lock: InlineLockAttrsSchema.optional(),
  /** Whether the node has a validation error (e.g., missing required config) */
  hasError: z.boolean().optional(),
});

/** Base type from schema inference (no index signature). Exported for use with Omit. */
export type MentionNodeBase = z.infer<typeof MentionNodeSchema_>;

/** Full type with index signature for FlowContentNode compatibility */
export type MentionNode = MentionNodeBase & { [key: string]: unknown };

/** Attrs type for tiptap (Omit done on base type before index signature) */
export type MentionNodeAttrs = Omit<MentionNodeBase, "type">;

export const MentionNodeSchema: z.ZodType<MentionNode> = MentionNodeSchema_;
